import { useSearchParams } from "react-router-dom";
import { DashboardLayout } from "@/components/DashboardLayout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BookOpen, PackageOpen } from "lucide-react";
import MenusAdminContent from "@/components/catalog/MenusAdminContent";
import PackagesAdminContent from "@/components/catalog/PackagesAdminContent";

export default function CatalogPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "menus";

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <DashboardLayout title="Catalog">
      <div className="space-y-6">
        <p className="text-muted-foreground text-sm">
          Manage your public-facing menus and catering packages.
        </p>

        <Tabs value={tab} onValueChange={handleTabChange}>
          <TabsList>
            <TabsTrigger value="menus" className="flex items-center gap-2">
              <BookOpen className="h-4 w-4" />
              Menus
            </TabsTrigger>
            <TabsTrigger value="packages" className="flex items-center gap-2">
              <PackageOpen className="h-4 w-4" />
              Packages
            </TabsTrigger>
          </TabsList>

          <TabsContent value="menus" className="mt-6">
            <MenusAdminContent />
          </TabsContent>

          <TabsContent value="packages" className="mt-6">
            <PackagesAdminContent />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
